import { render, staticRenderFns } from "./giftset-alert-template-grid.vue?vue&type=template&id=5a9a5845"
import script from "./giftset-alert-template-grid.vue?vue&type=script&lang=js"
export * from "./giftset-alert-template-grid.vue?vue&type=script&lang=js"
import style0 from "./giftset-alert-template-grid.vue?vue&type=style&index=0&id=5a9a5845&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports